<template>
  <div class="app-container" :class="languageClass">
    <!-- 导航栏 -->
    <NavBar :bgColor="navBarBgColor" :shouldShow="isTop && !isInSearchListPage"></NavBar>

    <!-- 页面内容 -->
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "./NavBar.vue";
import Footer from "./Footer.vue";
export default {
  components: {
    NavBar,
    Footer
  },
  data() {
    return {
      isInSearchListPage: false, // 是否显示搜索栏
      isTop: true, // 是否在顶部
      navBarBgColor: "transparent",
      scrollTopThreshold: 0, // 滚动阈值，默认为0表示最顶端
      needChangeNavBarBg: false,
      searchText: '',
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // console.log("scrolling");
      if (this.needChangeNavBarBg) {
        return
      }
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > this.scrollTopThreshold) {
        this.navBarBgColor = "#00579C";
        this.isTop = false;
      } else {
        this.navBarBgColor = "transparent";
        this.isTop = true;
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  },
  computed: {
    languageClass() {
      return this.$i18n.locale === 'en' ? 'en-font' : 'zh-font';
    }
  },
  watch: {
    $route(to, from) {
      console.log("route changed to: ", to);
      if (to.meta.changeNavBarBg) {
        this.navBarBgColor = "#00579C"; // 进入需要改变背景色的页面时立即改变背景色
        this.needChangeNavBarBg = true; // 标记需要改变背景色
      } else {
        this.navBarBgColor = "transparent"; // 进入不需要改变背景色的页面时恢复背景色
        this.needChangeNavBarBg = false; // 标记不需要改变背景色
      }
      this.scrollToTop();
      if (to.name === "SearchList") {
        this.isInSearchListPage = true;
      }else {
        this.isInSearchListPage = false;
      }
    },
    '$i18n.locale': function (newLocale) {
      // 可以在这里添加其他逻辑，比如重新加载某些资源
    }
  }
};
</script>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.en-font {
  font-family: 'Poppins', sans-serif !important;
}

.zh-font {
  font-family: 'MiSans', sans-serif !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Layout.vue